// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1868":"3bf779cd","2858":"8655a311","3754":"82499357","4679":"8b9b7c75","5468":"c0c603c1","7375":"ffd091b6","7850":"6d178cd7","8688":"496d5990"}[chunkId] + ".chunk.css";
};